import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const GetKycDetailsApi = createAsyncThunk(
  'GetKycDetailsApi',
  async (getKycDetailsPayload, { dispatch }) => {
    dispatch({ type: 'GetKycDetailsApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = getKycDetailsPayload;

    let payloadLocal = {
      customerRefNum,
      appId: APP_ID,
      appVersion: APP_VERSION,
    };
    if ('agentId' in getKycDetailsPayload) {
      const { agentId, merchantId } = getKycDetailsPayload;
      payloadLocal['agentId'] = agentId;
      payloadLocal['merchantId'] = merchantId;
    }
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/getkycdetails',
      payload: payloadLocal,
      //   payload: {
      //     customerRefNum,
      //     appId: APP_ID,
      //     appVersion: APP_VERSION,
      //   },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const additionalDocsRes = res;
        dispatch({
          type: 'GetKycDetailsApi/fulfilled',
          payload: additionalDocsRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'GetKycDetailsApi/rejected', payload: err });
      },
    });
  }
);

export const GetKycDetailsApi_extrareducer = {
  [GetKycDetailsApi.pending]: (state, action) => {
    state.getKycDetailsApiState.isLoading = true;
  },
  [GetKycDetailsApi.fulfilled]: (state, action) => {
    state.getKycDetailsApiState.isLoading = false;
    state.getKycDetailsApiState.isSuccess = true;
    state.getKycDetailsApiState.isError = false;
    state.getKycDetailsApiState.response = action.payload;
  },
  [GetKycDetailsApi.rejected]: (state, action) => {
    state.getKycDetailsApiState.isLoading = false;
    state.getKycDetailsApiState.isSuccess = false;
    state.getKycDetailsApiState.isError = true;
    state.getKycDetailsApiState.response = action.payload;
  },
};
